export const cardHeight = '14rem';
export const gridWidth = { xs: 12, md: 6, lg: 4, xl: 3 } as const;
